import { useBoolean } from 'usehooks-ts';

import { FundingInformationDialog } from '@organisms/AccountFundingDialog';
import { AccountFundingInformation } from '@organisms/AccountFundingDialog/AccountFundingInformation';

import { ACCOUNTS_FUNDING_SIDEBAR_TEST_ID } from '../constants';

export const AccountFundingItem = () => {
  const { value, toggle, setValue } = useBoolean(false);

  return (
    <>
      <a
        onClick={(e) => {
          e.stopPropagation();
          toggle();
        }}
        className="group flex h-12 cursor-pointer items-center whitespace-nowrap rounded-full px-7 text-sm hover:bg-gray-100"
        data-testid={ACCOUNTS_FUNDING_SIDEBAR_TEST_ID}
      >
        Account funding
      </a>
      <FundingInformationDialog
        open={value}
        onClose={setValue}
        FundingDetailsComponent={AccountFundingInformation}
      />
    </>
  );
};
